import { VDivider } from 'vuetify/lib/components/VDivider';
import { VResponsive } from 'vuetify/lib/components/VResponsive';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VResponsive,_vm._g(_vm._b({staticClass:"base-divider",class:_vm.classes,attrs:{"max-width":"28"}},'v-responsive',_vm.$attrs,false),_vm.$listeners),[_c(VDivider)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }